import { SAction } from "servisofts-model";
export default class Action extends SAction {
    // getByKey(key: any, extra: {}, _default: any) {
    //     let arr = super.getAll();
    //     if (!arr) return null;
    //     return arr.find(a => a.idus == key);
    // }
}